<template>
  <div class="dd-style-selector">
    <span class="dd-style-selector__label">{{ $t('generation.image_style') }}:</span>
    <dropdown-menu
      class="dd-style-selector__dropdown"
      transition="zoom"
      ref="dropdown"
      @opened="scrollIntoViewIfNeeded"
    >
      <template #trigger>
        <button
          type="button"
          class="dd-style-selector__trigger"
          :disabled="$store.getters.generationInProgress || $store.getters.generationDisabledGlobally"
        >
          <span>
            <template v-if="selectedEffectGenerationStylePreset">
              {{ $t(`generation.styles.${convertStyleKey(selectedEffectGenerationStylePreset.style)}`) }}
            </template>
            <template v-else>
              {{ $t('generation.select_style') }}
            </template>
          </span>
          <span class="dd-style-selector__chevron" aria-hidden="true"></span>
        </button>
      </template>
      <template #header>{{ $t('generation.select_style') }}</template>
      <template #body>
        <ul class="dd-style-selector__list">
          <li v-for="preset in availableStylePresets" :key="preset.ID">
            <button
              type="button"
              class="dd-style-selector__option"
              :class="{ 'is-selected': $store.getters.selectedEffectGenerationStylePresetID === preset.ID }"
              @click="changeStyle(preset.ID)"
            >
              <span class="dd-style-selector__thumb">
                <img :src="preset.imageURL" :alt="preset.style" />
              </span>
              <span class="dd-style-selector__name">
                {{ $t(`generation.styles.${convertStyleKey(preset.style)}`) }}
              </span>
            </button>
          </li>
        </ul>
      </template>
    </dropdown-menu>
  </div>
</template>

<script>
import DropdownMenu from 'v-dropdown-menu/vue2';
import '@/assets/css/v-dropdown-menu.css';

export default {
  name: 'StylePresetSelector',
  components: {
    DropdownMenu,
  },
  computed: {
    availableStylePresets() {
      return this.$store.getters.availableEffectGenerationStylePresets || [];
    },
    selectedEffectGenerationStylePreset() {
      return this.availableStylePresets.find(
        preset => preset.ID === this.$store.getters.selectedEffectGenerationStylePresetID,
      ) || null;
    },
  },
  methods: {
    handleTouchStart(event) {
      event.preventDefault();
      const img = event.target;
      if (event.touches.length === 1) {
        const touch = event.touches[0];
        const imgRect = img.getBoundingClientRect();
        img.style.transform = `translate(0px, ${touch.clientY - imgRect.top - imgRect.height - 24}px) scale(2.4)`;
      } else {
        img.style.transform = 'scale(2.37037037)';
      }
      img.style.transformOrigin = 'left bottom';
    },
    handleTouchEnd(event) {
      const img = event.target;
      img.style.transform = 'translate(0, 0) scale(1)';
      img.style.transformOrigin = 'left bottom';
    },
    disableContextMenu(event) {
      event.preventDefault();
    },
    changeStyle(styleID) {
      this.$store.dispatch('setSelectedEffectGenerationStylePresetID', styleID);
      this.closeDropdown();
    },
    closeDropdown() {
      this.$refs.dropdown?.hide();
    },
    convertStyleKey(style) {
      return style.replace(/-/g, '_').replace('3d', 'three_d');
    },
    scrollIntoViewIfNeeded() {
      this.$nextTick(() => {
        setTimeout(() => {
          const dropdown = this.$refs.dropdown.$el.querySelector('.v-dropdown-menu__container');
          if (dropdown) {
            const dropdownRect = dropdown.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            if (dropdownRect.bottom > viewportHeight) {
              const scrollDistance = dropdownRect.bottom - viewportHeight + 40;
              window.scrollBy({ top: scrollDistance, behavior: 'smooth' });
            }
          }
        }, 150);
      });
    },
  },
  mounted() {
    const images = this.$el.querySelectorAll('img');
    images.forEach(img => {
      img.addEventListener('touchstart', this.handleTouchStart, { passive: false });
      img.addEventListener('touchend', this.handleTouchEnd);
      img.addEventListener('contextmenu', this.disableContextMenu);
    });
  },
  beforeDestroy() {
    const images = this.$el.querySelectorAll('img');
    images.forEach(img => {
      img.removeEventListener('touchstart', this.handleTouchStart);
      img.removeEventListener('touchend', this.handleTouchEnd);
      img.removeEventListener('contextmenu', this.disableContextMenu);
    });
  },
};
</script>
